module.exports = __webpack_public_path__ + "static/img/title-banner1-type2.0614b08.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/4/title-banner1-type2.png
// module id = BGpP
// module chunks = 1